import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useHistory, generatePath } from "react-router-dom";

import Placeholder from "components/Placeholder";
import { ScrollLoader, TriviaCardWrapper } from "./styles";
import TriviaCard from "./TriviaCard";
import { Trivia } from "../TriviaStore";
import ROUTES from "navigation/routes";

const HEADER_WITH_TITLE_HEIGHT = "338px";

interface ListProps<T> {
  isEmpty: boolean;
  text: string;
  items?: T;
  hasMoreInfo?: boolean;
  onPublish: (payload: any) => void;
  fetchMore?: () => void;
}

const List = ({
  isEmpty,
  text,
  items = [],
  hasMoreInfo = true,
  fetchMore = () => {},
  onPublish,
}: ListProps<Trivia[]>) => {
  const history = useHistory();

  const onDetailsClick = (id: number) => {
    const path = generatePath(ROUTES.CONTENT_TRIVIA_DETAIL, {
      triviaId: id,
    });
    history.push({ pathname: path, state: { editMode: false } });
  };

  const onEditClick = (id: number) => {
    const path = generatePath(ROUTES.CONTENT_TRIVIA_DETAIL, {
      triviaId: id,
    });
    history.push({ pathname: path, state: { editMode: true } });
  };

  if (isEmpty) {
    return <Placeholder height={280} width={280} text={text} />;
  }

  return (
    <InfiniteScroll
      dataLength={items.length}
      hasMore={hasMoreInfo}
      next={fetchMore}
      height={`calc(100vh - ${HEADER_WITH_TITLE_HEIGHT})`}
      loader={<ScrollLoader />}
    >
      {items.map((trivia: Trivia) => (
        <TriviaCardWrapper key={trivia.id}>
          <TriviaCard
            onDetailsClick={() => onDetailsClick(trivia.id)}
            onEdit={() => onEditClick(trivia.id)}
            title={trivia.title}
            publishStatus={trivia.publishStatus}
            onPublish={() => onPublish(trivia)}
          />
        </TriviaCardWrapper>
      ))}
    </InfiniteScroll>
  );
};

export default List;
